<template>
	<div class="page-wrapper">
		<div v-if="is_token_valid && !is_submitted && !is_loading" class="review-card">
			<div class="d-flex" style="align-items: center; justify-content: center; gap: 10px;">
			<img width="50px" style="object-fit: contain; " :src="sp_logo_url" alt="" />
			<h1 class="large">{{ service_provider_name }}</h1>
			</div>
			<hr>
			<h2 class="medium">{{ location_name }}</h2>
			<h3 class="small">{{ location_address }}</h3>
			<h4 class="extra-small">{{ location_contact }}</h4>

			<h2 style="margin-top: 25px; color: #1BC5BD;">Submit Your Review</h2>

			<div class="star-rating" v-if="rating === null">
				<label v-for="star in 5" :key="star" class="star">
					<input type="radio" :name="'rating'" :value="star" v-model="rating" style="display: none;" />
					<span class="star-icon" :class="{ 'filled': star <= (hoverRating || rating) }"
						@mouseover="hoverRating = star" @mouseleave="hoverRating = 0" @click="handleRating(star)">
						<strong>★</strong>
					</span>
				</label>
			</div>

			<div class="review-text" v-if="rating <= 4 && rating !== null">
				<textarea v-model="review" placeholder="Write your review..."></textarea>
			</div>

			<div class="anonymous-option">
				<input type="checkbox" v-model="isAnonymous" id="anonymous" class="fancy-checkbox" />
				<label for="anonymous" class="fancy-checkbox-label">
					Send as Anonymous
				</label>
			</div>

			<button @click="submitReview" v-if="rating <= 4 && rating !== null">Submit Review</button>
		</div>

		<div v-if="is_submitted && !is_loading && !(google_business_url && rating == 5)" class="review-card">
			<h1 class="large"> Thank You!</h1>
			<p>Your review has been submitted successfully.</p>
			<p>We appreciate your feedback! 💬</p>
			<button @click="closeWindow">Close Window</button>
		</div>

		<div v-if="!is_token_valid && !is_loading" class="expired-wrapper">
			<div class="expired-card">
				<h1>Link Expired</h1>
				<p>Your review link has expired or is invalid.</p>
				<button @click="closeWindow">Close Window</button>
			</div>
		</div>
	</div>
</template>


<script>
import {
	VERIFY_FEEDBACK_TOKEN,
	SUBMIT_FEEDBACK
} from "@/core/services/store/actions.type";

export default {
	data() {
		return {
			rating: null,
			hoverRating: 0,
			review: "",
			isAnonymous: false,
			is_token_valid: false,
			service_provider_name: "",
			location_name: "",
			location_address: "",
			location_contact: "",
			is_submitted: false,
			is_loading : false,
			google_business_url: "",
			sp_logo_url: ""
		};
	},

	created() {
		let review_token = this.$route.query.token;

		if (!review_token || review_token == "None") {
			// this.$router.push("/");
			return;
		}
		this.checkUrlToken(review_token);
	},
	methods: {
		async handleRating (star) {
			this.rating = star;
			if (star == 5) {
				await this.submitReview();
				console.log(this.google_business_url, "k cha");
				if (this.google_business_url){
					window.open(this.google_business_url, "_self");
					return ; 
				}
			}
			this.is_loading = false;
		},
		async submitReview() {
			this.is_loading = true;
			
			if (!this.rating) {
				this.$toastr.e("Please select at least one star before submitting.");
				return null;
			}

			try{
				const data = await this.$store
				.dispatch(SUBMIT_FEEDBACK, {

					rating: this.rating,
					review: this.review,
					isAnonymous: this.isAnonymous,
					token: this.$route.query.token

				});
					if (data.success) {
						this.google_business_url = data.data.google_business_url
						this.$toastr.s(data.msg);
						this.is_submitted = true;
						this.is_loading = false;
					} else {
						this.$toastr.e(data.msg);
					}
					this.is_token_valid = true;
					return true;
			}
			
					

				catch(err){
					this.$toastr.e(err.error);
					this.is_token_valid = false;
;
					return false;
				};


		},
		closeWindow() {
			window.close();
		},
		checkUrlToken(token) {
			this.is_loading = true;
			this.$store
				.dispatch(VERIFY_FEEDBACK_TOKEN, {
					token: token,
				})
				.then(data => {
					if (data.success) {
						this.service_provider_name = data.data.service_provider_name;
						this.location_name = data.data.location_name;
						this.location_address = data.data.location_address;
						this.location_contact = data.data.location_contact;
						this.sp_logo_url = data.data.sp_logo_url;
						this.is_loading = false;
					} else {
						this.$toastr.e(data.msg);
					}
					this.is_token_valid = true;
					return true;
				})
				.catch(err => {
					this.is_loading = false;
					return false;
				});
		},
	}
};
</script>

<style scoped>
html,
body {
	margin: 0;
	padding: 0;
	height: 100%;
	font-family: Arial, sans-serif;
	font-size: 18px;
}

.page-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100vw;
	background-color: #f0f0f0;
	box-sizing: border-box;
	padding: 20px;
}

.review-card {
	background: white;
	padding: 50px;
	border-radius: 16px;
	box-shadow: 0 6px 30px rgba(0, 0, 0, 0.1);
	width: 100%;
	max-width: 600px;
	text-align: center;
}

.star-rating {
	margin: 20px 0;
}

.star {
	display: inline-block;
	cursor: pointer;
	margin-right: 5px;
}

.star-icon {
	font-size: 50px;
	color: #ccc;
	transition: color 0.2s;
	user-select: none;
}

.star-icon.filled {
	color: gold;
}

.review-text textarea {
	width: 100%;
	height: 150px;
	margin-top: 20px;
	padding: 15px;
	font-size: 18px;
	border: 1px solid #ccc;
	border-radius: 10px;
	resize: vertical;
}

.anonymous-option {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	margin-top: 25px;
	font-size: 18px;
}

.fancy-checkbox {
	display: none;
}

.fancy-checkbox-label {
	position: relative;
	padding-left: 35px;
	font-size: 14px;
	cursor: pointer;
	user-select: none;
}

.fancy-checkbox-label::before {
	content: "";
	position: absolute;
	left: 9px;
	top: 0px;
	width: 20px;
	height: 20px;
	background-color: #f0f0f0;
	border: 2px solid #ccc;
	border-radius: 4px;
	transition: background-color 0.3s ease, border-color 0.3s ease;
}

.fancy-checkbox:checked+.fancy-checkbox-label::before {
	background-color: #1BC5BD;
	border-color: #1BC5BD;
}

.fancy-checkbox:checked+.fancy-checkbox-label::after {
	content: "✔";
	position: absolute;
	left: 11px;
	top: -4px;
	color: white;
	font-size: 20px;
	transition: 0.3s ease;
}

button {
	margin-top: 25px;
	padding: 10px 20PX;
	font-size: 15px;
	background-color: #1bc5bd;
	color: white;
	border: none;
	border-radius: 8px;
	cursor: pointer;
	transition: background-color 0.3s;
}

button:hover {
	background-color: #1BC5BD;
	opacity: 0.8;
}

.large {
	font-size: 2em;
}

.medium {
	font-size: 1.2em;
}

.small {
	font-size: 1em;
}

.extra-small {
	font-size: 0.8em;
}

/* 
	.expired-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f8f9fa;
  padding: 20px;
} */

.expired-card {
	background: white;
	padding: 50px 40px;
	border-radius: 16px;
	box-shadow: 0 6px 30px rgba(0, 0, 0, 0.1);
	text-align: center;
	max-width: 500px;
	width: 100%;
}

.expired-card h1 {
	font-size: 2.5em;
	margin-bottom: 20px;
	color: #dc3545;
}

.expired-card p {
	font-size: 1.2em;
	margin-bottom: 25px;
	color: #6c757d;
}

.expired-card button {
	padding: 10px 20PX;
	font-size: 15px;
	background-color: #1bc5bd;
	color: white;
	border: none;
	border-radius: 8px;
	cursor: pointer;
	transition: background-color 0.3s;
}

.expired-card button:hover {
	background-color: #17a2b8;
}
</style>
